import {TicketStatusCategory} from '@frontapp/ticketing';
import React, {FC} from 'react';
import {DefaultTheme, useTheme} from 'styled-components';

import {ticketStatusCategoryColors} from '../../../../libs/inboxes/ui/src/ticketing/ticketStatus';
import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';

/*
 * Props.
 */

interface TicketStatusIndicatorProps {
  category: TicketStatusCategory;
  isSelected?: boolean;
  isDarker?: boolean;
  size?: number;
}

/*
 * Component.
 */

export const TicketStatusIndicator: FC<TicketStatusIndicatorProps> = ({
  category,
  isDarker,
  isSelected,
  size,
}) => {
  const theme = useTheme();

  return (
    <Icon
      name="squareFilledSmall"
      color={computeIconColor(category, theme, {isDarker, isSelected})}
      size={size}
    />
  );
};

function computeIconColor(
  category: TicketStatusCategory,
  theme: DefaultTheme,
  options: Pick<TicketStatusIndicatorProps, 'isDarker' | 'isSelected'>,
) {
  if (options.isSelected) {
    return theme.alphas.white50;
  }

  const color = theme.palette[ticketStatusCategoryColors[category]];
  return options.isDarker ? color.shade50 : color.shade40;
}
